import React, { Component } from 'react';
import { debounce } from 'lodash';
import { Modal, ModalBody, ModalFooter, Message, ProgressIndicator, Button } from 'sabre-spark-react';
import { LinearProgressBar } from '../widgets/LinearProgressBar';
import { LOGIN_EXPIRATION_TIMEOUT, LOGIN_EXPIRATION_WARNING } from '../../constants/LoginConfig';
import { OAuthActions } from '../../config/Authentication';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class ModalSessionExpiration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expiresIn: LOGIN_EXPIRATION_TIMEOUT,
            isOpen: false
        };
        this.extendTokenTime = debounce(this.extendTokenTime.bind(this), 1000);
    }
    _addRenewEvents() {
        this.routeChangeHook = this.props.router.listenBefore(this.extendTokenTime);
        document.addEventListener('click', this.extendTokenTime);
    }
    _removeBindEvents() {
        if (this.routeChangeHook) {
            this.routeChangeHook();
        }
        document.removeEventListener('click', this.extendTokenTime);
    }
    componentDidMount() {
        this.sessionTimerId = setInterval(() => this.tick(), 1000);
        this._addRenewEvents();
    }
    componentWillUnmount() {
        clearInterval(this.sessionTimerId);
        this._removeBindEvents();
    }
    extendTokenTime() {
        this.setState({
            expiresIn: LOGIN_EXPIRATION_TIMEOUT,
            isOpen: false
        });
    }
    tick() {
        const nextTimeUpdate = Math.max(0, this.state.expiresIn - 1);
        this.setState({
            expiresIn: nextTimeUpdate,
            isOpen: nextTimeUpdate <= LOGIN_EXPIRATION_WARNING && nextTimeUpdate > 0
        });
        if (nextTimeUpdate === 0) {
            this.props.signOut();
        }
    }
    render() {
        const percentage = (100 * (LOGIN_EXPIRATION_WARNING - this.state.expiresIn)) / LOGIN_EXPIRATION_WARNING;
        return (
            <Modal isOpen={this.state.isOpen} isComplex={true} isNotDismissible={true}>
                <ModalBody>
                    <Message title="Your session is about to expire." type="warning" inline={true} />
                    <LinearProgressBar percent={percentage} strokeWidth="5" trailWidth="5" strokeLinecap="square" />
                </ModalBody>
                <ModalFooter>
                    <nav className="spark-btn-group">
                        <Button secondary={true} onClick={() => this.props.signOut()}>
                            Logout
                        </Button>
                        <Button onClick={() => this.extendTokenTime()}>
                            ({this.state.expiresIn}) Keep Session Active
                        </Button>
                    </nav>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    signOut: () => dispatch(OAuthActions.signout())
});
const ModalSessionExpirationConnected = withRouter(connect(null, mapDispatchToProps)(ModalSessionExpiration));
export { ModalSessionExpirationConnected as ModalSessionExpiration };



// WEBPACK FOOTER //
// ./src/components/modals/ModalSessionExpiration.js